import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

const Footer = () => {
  return (
    <footer className="section-dark footer">
      <div className="container">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-section">
            <img 
              src="/logowhite.png" 
              alt="Blackswift Inventories" 
              className="footer-logo"
            />
            <p className="footer-text">
              Your trusted route-to-market partner in Southern Africa, 
              providing integrated supply chain solutions and brand stewardship.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-heading">Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">Our Story</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h3 className="footer-heading">Contact Us</h3>
            <div className="footer-contact-info">
              <div className="footer-address">
                <h4 className="address-title">Malawi Office</h4>
                <p className="address-text">
                  John Chilembwe RD, Area 4<br />
                  Accord Centre Building,<br />
                  Block B, 188.<br />
                  Lilongwe,<br />
                  Malawi.<br />
                </p>
              </div>
              <div className="footer-address">
                <h4 className="address-title">South Africa Office</h4>
                <p className="address-text">
                  137 9th Carlswald, Midrand<br />
                  1685 South Africa<br />
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright, Developer Credit, and Social Icons */}
        <div className="footer-bottom">
          <div className="copyright">
            <p>&copy; {new Date().getFullYear()} Blackswift Inventories. All rights reserved.</p>
          </div>
          <div className="footer-social">
            <a href="https://x.com/blackswift" target="_blank" rel="noopener noreferrer" aria-label="X">
              <i className="fab fa-x-twitter"></i>
            </a>
            <a href="https://facebook.com/blackswift" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://instagram.com/blackswift" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
          <div className="developer-credit">
            <p>
              Developed by{' '}
              <a 
                href="https://www.beleae.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="developer-link"
              >
                Belea Enterprise
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;